(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cart-summary"] && !Shopify.designMode) return;
  try {
    if (!window.__pdlCartClearBound) {
    window.__pdlCartClearBound = true;

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-pdl-clear-cart]');
      if (!button || button.disabled) return;

      const confirmed = window.confirm('Tem certeza que deseja remover todos os itens do carrinho?');
      if (!confirmed) return;

      const label = button.querySelector('[data-pdl-clear-label]');
      const originalLabel = label ? label.textContent : 'Limpar carrinho';
      button.disabled = true;
      if (label) label.textContent = 'Limpando...';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/clear.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (!response.ok) throw new Error('Falha ao limpar carrinho');
        window.location.reload();
      } catch (error) {
        button.disabled = false;
        if (label) label.textContent = originalLabel;
        window.alert('Não foi possível limpar o carrinho. Tente novamente.');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdl-cart-recommendations"] && !Shopify.designMode) return;
  try {
    class PdlCartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      this.load();
    }

    async load() {
      const url = this.dataset.url;
      if (!url) {
        this.remove();
        return;
      }

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error();

        const documentHtml = new DOMParser().parseFromString(await response.text(), 'text/html');
        const source = documentHtml.getElementById(this.id);

        if (!source || !source.querySelector('.pdl-cart-recommendations__grid')) {
          this.remove();
          return;
        }

        this.innerHTML = source.innerHTML;
        this.hidden = false;
      } catch {
        this.remove();
      }
    }
  }

  if (!customElements.get('pdl-cart-recommendations')) {
    customElements.define('pdl-cart-recommendations', PdlCartRecommendations);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdl-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdl-size-guide')) {
    customElements.define('pdl-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('.pdl-size-guide__trigger');
        if (!this.dialog || !this.trigger) return;
        this.trigger.addEventListener('click', () => {
          this.dialog.showModal();
          document.documentElement.classList.add('pdl-size-guide-open');
        }, options);
        this.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          if (!document.querySelector('.pdl-size-guide__dialog[open]')) document.documentElement.classList.remove('pdl-size-guide-open');
          this.trigger.focus({ preventScroll: true });
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        if (!document.querySelector('.pdl-size-guide__dialog[open]')) document.documentElement.classList.remove('pdl-size-guide-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
